import React, { useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { onPendingChange } from "@/lib/api";

// Thin red progress bar fixed at the top; grows while requests are pending, completes when idle.
export function LoadingBar() {
  const [progress, setProgress] = useState(0);
  const [visible, setVisible] = useState(false);
  const timer = useRef(null);
  const pendingRef = useRef(0);
  const loc = useLocation();

  useEffect(() => {
    const start = () => {
      clearInterval(timer.current);
      setVisible(true);
      setProgress((p) => (p > 0 && p < 90 ? p : 8));
      timer.current = setInterval(() => setProgress((p) => (p < 90 ? p + Math.max(0.5, (90 - p) / 12) : p)), 120);
    };
    const finish = () => {
      clearInterval(timer.current);
      setProgress(100);
      setTimeout(() => { setVisible(false); setProgress(0); }, 350);
    };
    return onPendingChange((n) => { pendingRef.current = n; return n > 0 ? start() : finish(); });
  }, []);

  useEffect(() => {
    setVisible(true); setProgress((p) => (p > 0 ? p : 8));
    const t = setTimeout(() => { if (!pendingRef.current) { setProgress(100); setTimeout(() => { setVisible(false); setProgress(0); }, 350); } }, 400);
    return () => clearTimeout(t);
  }, [loc.pathname]);

  return (
    <div className="fixed top-0 left-0 right-0 z-[100] h-[3px] pointer-events-none" data-testid="loading-bar" aria-hidden="true">
      <div className="h-full bg-red-600 shadow-[0_0_12px_rgba(229,9,20,0.9)]"
        style={{ width: `${progress}%`, opacity: visible ? 1 : 0, transition: "width 200ms ease-out, opacity 300ms ease" }} />
    </div>
  );
}
